export default __webpack_public_path__ + "static/media/actividad-25.e7d83163.mp3";